// Helper function to get backend data URL
const getDataUrl = (path) => {
  const API_BASE = process.env.REACT_APP_API_URL?.replace('/api', '') || 'http://localhost:5001';
  const url = `${API_BASE}/data/${path}`;
  console.log('🔗 Building data URL:', url);
  return url;
};

// Data caching service to avoid reloading Excel files
class DataCache {
  constructor() {
    this.cache = {
      atlData: null,
      obdData: null,
      newData: null,
      mdmData: null,
      processedData: null,
      platformMapping: null,
      storeNameMapping: null,
      lastFetch: null
    };
    this.cacheTimeout = 5 * 60 * 1000; // 5 minutes cache
  }

  isExpired() {
    if (!this.cache.lastFetch) return true;
    return Date.now() - this.cache.lastFetch > this.cacheTimeout;
  }

  clearCache() {
    this.cache = {
      atlData: null,
      obdData: null,
      newData: null,
      mdmData: null,
      processedData: null,
      platformMapping: null,
      storeNameMapping: null,
      lastFetch: null
    };
  }

  async getExcelData(readExcelFile) {
    if (!this.isExpired() && this.cache.atlData && this.cache.obdData && this.cache.newData && this.cache.mdmData) {
      console.log('Using cached Excel data');
      return {
        atlData: this.cache.atlData,
        obdData: this.cache.obdData,
        newData: this.cache.newData,
        mdmData: this.cache.mdmData
      };
    }

    console.log('Loading Excel data from files...');
    
    // Load all files in parallel for better performance
    const [atlData, obdData, newData, mdmData] = await Promise.all([
      readExcelFile(getDataUrl('atl 4-14-to 6-28.xlsx')),
      readExcelFile(getDataUrl('OBD Data from Scott at the DC V1W 06262025.XLSX')),
      readExcelFile(getDataUrl('Copy of All 6-29-to 7-29.xlsx')),
      readExcelFile(getDataUrl('2024 MDM.xlsx'))
    ]);

    // Cache the raw data
    this.cache.atlData = atlData;
    this.cache.obdData = obdData;
    this.cache.newData = newData;
    this.cache.mdmData = mdmData;
    this.cache.lastFetch = Date.now();

    return { atlData, obdData, newData, mdmData };
  }

  getProcessedData() {
    return this.cache.processedData;
  }

  setProcessedData(data) {
    this.cache.processedData = data;
  }

  getPlatformMapping() {
    return this.cache.platformMapping;
  }

  setPlatformMapping(mapping) {
    this.cache.platformMapping = mapping;
  }

  getStoreNameMapping() {
    return this.cache.storeNameMapping;
  }

  setStoreNameMapping(mapping) {
    this.cache.storeNameMapping = mapping;
  }
}

// Create singleton instance
const dataCache = new DataCache();

export default dataCache;